/**
 * Collection Infinite Scroll
 * Loads more products as the user scrolls near the bottom using Shopify Section Rendering API.
 */
(function () {
  'use strict';

  var container = document.querySelector('.collection-infinite-scroll-container');
  if (!container) return;

  var nextUrl = container.dataset.nextUrl;
  var sectionId = container.dataset.sectionId;
  if (!sectionId) return;

  if (!nextUrl) return; // Single page, nothing to load

  var grid = document.getElementById('collection-products-grid');
  var loadMore = document.getElementById('collection-load-more');
  var sentinel = document.getElementById('collection-load-more-sentinel');
  var loadingEl = document.getElementById('collection-loading-indicator');
  var errorEl = document.getElementById('collection-load-more-error');
  var retryBtn = document.getElementById('collection-retry-btn');

  var isLoading = false;
  var hasMore = true;
  var abortController = null;

  function getFetchUrl(useSectionId) {
    var url = nextUrl;
    if (useSectionId !== false) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      return url + separator + 'section_id=' + encodeURIComponent(sectionId);
    }
    return url;
  }

  function showLoading() {
    isLoading = true;
    if (loadingEl) loadingEl.classList.remove('hidden');
    if (errorEl) errorEl.classList.add('hidden');
  }

  function hideLoading() {
    isLoading = false;
    if (loadingEl) loadingEl.classList.add('hidden');
  }

  function showError() {
    if (loadingEl) loadingEl.classList.add('hidden');
    if (errorEl) errorEl.classList.remove('hidden');
  }

  function hideError() {
    if (errorEl) errorEl.classList.add('hidden');
  }

  function appendProducts(html) {
    if (!grid) return;
    if (html.indexOf('No products found') !== -1) {
      hasMore = false;
      return;
    }
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newGrid = doc.getElementById('collection-products-grid');
    var newLoadMore = doc.getElementById('collection-load-more');
    if (newGrid && newGrid.children.length) {
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < newGrid.children.length; i++) {
        fragment.appendChild(newGrid.children[i].cloneNode(true));
      }
      grid.appendChild(fragment);
      announceToScreenReader(newGrid.children.length);
    }
    if (newLoadMore) {
      var newNext = newLoadMore.dataset.nextUrl;
      nextUrl = newNext || '';
      hasMore = !!newNext;
    } else {
      hasMore = false;
    }
  }

  function announceToScreenReader(count) {
    var announce = document.getElementById('collection-aria-announce');
    if (announce) {
      announce.textContent = 'Loaded ' + count + ' more product' + (count === 1 ? '' : 's');
    }
  }

  function loadMoreProducts(useSectionId) {
    if (!hasMore || isLoading || !nextUrl) return;

    showLoading();
    if (abortController) abortController.abort();
    abortController = new AbortController();

    var fetchUrl = getFetchUrl(useSectionId);
    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      signal: abortController.signal
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (typeof html !== 'string' || !html.trim()) {
          throw new Error('Empty response');
        }
        appendProducts(html);
        hideLoading();
        if (!hasMore && loadMore) {
          loadMore.style.display = 'none';
          observer.disconnect();
        }
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        console.error('[CollectionInfiniteScroll]', err);
        if (useSectionId !== false) {
          loadMoreProducts(false);
        } else {
          hideLoading();
          showError();
        }
      });
  }

  function setupRetry() {
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        hideError();
        loadMoreProducts();
      });
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && hasMore && !isLoading) {
          loadMoreProducts();
        }
      });
    },
    {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0
    }
  );

  if (sentinel) {
    observer.observe(sentinel);
  }

  setupRetry();
})();
